module.exports = __webpack_public_path__ + "img/ground-tile-spring.cfe67043.jpg";